import React, { useState, useEffect } from "react";
import CharityModal from "./CharityModal";
import { getCharitysById, updateCharity } from "../../api/charityApi";
import { submitApproval } from "../../api/approvalApi";
import { useToast } from "../../context/ToastContext";
import { CONTENT_TYPES } from '../../constants/contentTypes';

const EditCharityModal = ({
  open,
  charityId,
  onClose,
  onSuccess,
  readOnly = false,
  approvalMode = false,
  overrideData = null,
  overrideSpaceId = null,
}) => {
  const [charity, setCharity] = useState(null);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    if (!open) return;
    if (overrideData) {
      setCharity(overrideData);
      setLoading(false);
      return;
    }
    if (!charityId) return;
    setLoading(true);
    getCharitysById(charityId, overrideSpaceId)
      .then((res) => setCharity(res.data || res))
      .catch((err) => {
        console.error("Failed to load charity:", err);
        // error shown globally via axios interceptor → toast
        onClose();
      })
      .finally(() => setLoading(false));
  }, [open, charityId, overrideData, overrideSpaceId]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSave = async (payload) => {
    try {
      if (approvalMode) {
        const contentName = payload.localizedName?.values?.[0]?.value || `Charity ${charityId}`;
        await submitApproval({
          contentType: CONTENT_TYPES.CHARITY,
          contentId: charityId,
          contentName: contentName,
          actionType: 'edit',
          proposedData: JSON.stringify(payload),
          proposedSnapshot: JSON.stringify(payload),
        });
        toast.success("Edit submitted for approval!");
        onSuccess?.();
        onClose();
      } else {
        await updateCharity(charityId, payload);
        onSuccess?.();
        onClose();
      }
    } catch (err) {
      console.error("Failed to save charity:", err);
      // error shown globally via axios interceptor → toast
    }
  };

  return (
    <CharityModal
      open={open}
      onClose={onClose}
      onSave={handleSave}
      mode="edit"
      initialData={charity}
      loading={loading}
      readOnly={readOnly}
    />
  );
};

export default EditCharityModal;
